/* eslint-disable import/prefer-default-export */
import { QueryClient, UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query";
import { getStatesV2 } from "api/services/common";
import { GetStatesV2ResponseType } from "api/response";
import { commonQueryKeys } from "./commonQueryKeys";

/**
 * Imperative counterpart to useGetStatesV2, for event handlers that need the list on demand.
 * Shares the cache key with the hook so both dedupe onto a single request.
 */
export function fetchStatesV2Query(queryClient: QueryClient, country: number): Promise<GetStatesV2ResponseType> {
  return queryClient.fetchQuery({
    queryKey: commonQueryKeys.statesV2(country),
    queryFn: () => getStatesV2(country).then((res) => res.data),
  });
}

export function useGetStatesV2<T = GetStatesV2ResponseType>(
  country: number,
  options?: UseQueryOptions<GetStatesV2ResponseType, unknown, T>,
): UseQueryResult<T> {
  return useQuery<GetStatesV2ResponseType, unknown, T>({
    queryKey: commonQueryKeys.statesV2(country),
    queryFn: () => getStatesV2(country).then((res) => res.data),
    refetchOnMount: false,
    enabled: !!country,
    ...options,
  });
}
